export default __webpack_public_path__ + "static/medicaid-52f16bf75d3f0c896dacaa9f6f959f19.svg";